---
title: i can't be cool if
subtitle: i want to be cool
date: 2024-03-07 21:07
---

i can't be cool if i want to be cool, because coolness is like falling in love or enlightenment, something you can't get by chasing it directly

i can't be cool if i'm not constantly moving, writing, publishing, creating, working. i can't be cool staying still. i can't be cool if i'm not vibrating with content for the world to look at and say "that's cool"

i can't be cool if people aren't looking and liking and appreciating the things i make, i can't be cool if the numbers aren't going up, and i [envy the people](/post/contemplating-envy) who make cool things

i can't be cool if i'm depressed, because being sad isn't cool i guess, and i can't be cool if i'm a downer, i can't be cool if people who hang out with me end up sadder

i can't be cool if people don't like me; that's the anchor of my personality. i think of myself as a cool person, but more than that, i think of myself as someone other people think of as a cool person. my base needs are to be seen and noticed and praised

i can't be cool because there's only two people in the world who can say that i'm cool and make it matter to me, and there's no way they'll say it because they never thought of me as cool, and they never will

i can't be cool even if i had the rest of my life to try. in the scale of things twenty-three is young, but it seems like everyone cool was already cool when they were twenty-three, so why bother

i can't be cool unless i outdo myself every once in a while, i can't be cool if i'm not setting higher and higher bars for myself, i can't be cool if i'm not beating my personal bests, and i can't be cool if the best days of my life are past me

i can't be cool if i'm satisfied with the way my life is going, because then i would stop striving. i can't be cool if i'm secure in myself. i can't be cool if the only person i need to like me is me
